import {Component} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

@Component({
  selector: 'app-pre-order-error-message-modal',
  templateUrl: './pre-order-error-message-modal.component.html',
  styleUrls: ['./pre-order-error-message-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class PreOrderErrorMessageModalComponent {

}
